import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import Computer from "../../actors/computer";
import HtmlHud from "../../ui/htmlHud";
import Cowboy from "../../actors/characters/cowboy";
import OldMan from "../../actors/characters/oldMan";
import HippyChick from "../../actors/characters/hippyChick";
import Kaison from "../../actors/characters/kaison";
import InventoryHUD from "../../ui/inventory";
import Ronald from "../../actors/characters/ronald";
import { playerState } from "../../state/stateManager";
import Linda from "../../actors/characters/linda";
import Marvin from "../../actors/characters/marvin";
import Girl from "../../actors/characters/girl";
import FarmerJackson from "../../actors/characters/farmerJackson";
import { createNotification } from "../../utils";
export class Town extends ex.Scene {
  constructor() {
    super();
    const player = new Player(15 * 16, 8 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 3;
    this.oldMan = new OldMan({ x: 48 * 16, y: 42 * 16 }, "town");
    this.computerCollision = false;
    this.kaison = new Kaison({ x: 45 * 16, y: 40 * 16 }, "town");
    this.kaison.z = 4;
    this.computerCollision = false;
    this.showingInventory = false;
    this.ronald = new Ronald({ x: 29 * 16, y: 6 * 16 }, "town");
    this.linda = new Linda({ x: 64 * 16, y: 21 * 16 }, "town");
    this.marvin = new Marvin({ x: 5 * 16, y: 51 * 16 }, "town");
    this.marvin.z = 3;
    this.liv = new Girl({ x: 40 * 16, y: 42 * 16 }, "town");
  }
  onInitialize(engine) {
    Resources.TownMap.addToScene(this);

    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.player.wearingVeil = false;
    this.add(this.oldMan);
    this.add(this.kaison);
    this.add(this.liv);
    // this.player = Resources.HouseMap.getObjectsByName("player");
    this.camera.strategy.lockToActor(this.player);

    this.camera.zoom = 1;
    const map_bounds = ex.BoundingBox.fromDimension(
      Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
      Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
      ex.Vector.Zero,
      Resources.TownMap.pos
    );
    this.camera.strategy.limitCameraBounds(map_bounds);

    this.hippyChick = new HippyChick({ x: 30 * 16, y: 34 * 16 }, "town");
    this.hippyChick.scene = "town";
    this.add(this.hippyChick);
    this.hippyChick.z = 3;

    this.door = new ex.Trigger({
      pos: new ex.Vector(30 * 16, 0 * 16 + 8),
      width: 45,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("crossroads", { x: 20 * 16, y: 19 * 16, direction: "up" });
      },
    });
    this.add(this.door);
    this.lindasDoor = new ex.Trigger({
      pos: new ex.Vector(35 * 16, 6 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("lindasHouse", { x: 20 * 16, y: 18 * 16, direction: "up" });
      },
    });
    this.add(this.lindasDoor);
    this.kevinsDoor = new ex.Trigger({
      pos: new ex.Vector(62 * 16, 3 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("kevinsHouse", { x: 20 * 16, y: 17 * 16, direction: "up" });
      },
    });
    this.add(this.kevinsDoor);
    this.marvinsDoor = new ex.Trigger({
      pos: new ex.Vector(5 * 16, 46 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("marvinsHouse", { x: 20 * 16, y: 18 * 16, direction: "up" });
      },
    });
    this.add(this.marvinsDoor);

    this.margiesDoor = new ex.Trigger({
      pos: new ex.Vector(6 * 16, 6 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("margies", { x: 16 * 16, y: 17 * 16, direction: "up" });
      },
    });
    this.add(this.margiesDoor);
    this.sparkysDoor = new ex.Trigger({
      pos: new ex.Vector(65 * 16, 52 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("sparkys", { x: 19 * 16, y: 16 * 16, direction: "up" });
      },
    });
    this.add(this.sparkysDoor);
    this.farDoor = new ex.Trigger({
      pos: new ex.Vector(17 * 16, 26 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("farmersMarket", { x: 17 * 16, y: 17 * 16, direction: "up" });
      },
    });
    this.add(this.farDoor);

    this.bigBensDoor = new ex.Trigger({
      pos: new ex.Vector(67 * 16 + 8, 32 * 16 - 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("bigBens", { x: 16 * 16, y: 18 * 16, direction: "up" });
      },
    });
    this.add(this.bigBensDoor);

    this.furdlandDoor = new ex.Trigger({
      pos: new ex.Vector(64 * 16, 18 * 16 + 8),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("furdland", { x: 26 * 16, y: 15 * 16, direction: "up" });
      },
    });
    this.add(this.furdlandDoor);
    this.beeClubDoor = new ex.Trigger({
      pos: new ex.Vector(39 * 16 + 8, 31 * 16),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("beeClub", { x: 27 * 16, y: 19 * 16, direction: "up" });
      },
    });
    this.add(this.beeClubDoor);

    this.mccartysDoor = new ex.Trigger({
      pos: new ex.Vector(37 * 16 + 6, 19 * 16),
      width: 32,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("mccartys", { x: 18 * 16, y: 18 * 16 });
      },
    });
    this.add(this.mccartysDoor);
    this.player.on("collisionstart", (e) => {
      console.log("collided: ", e);
      this.interacting = e.other.owner.name;
      if (
        this.interacting == "linda" ||
        this.interacting == "roger" ||
        this.interacting == "ronald" ||
        this.interacting == "marvin" ||
        this.interacting == "jackson" ||
        this.interacting == "liv" ||
        this.interacting == "kaison" ||
        this.interacting == "oldMan"
      ) {
        createNotification("Space: Interact").create();
      }
    });
    this.player.on("collisionend", (e) => {
      this.interacting = null;
      createNotification().destroy();
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    this.hud = new HtmlHud();
    let content = playerState.getContent();
    if (content.npcLocations.ronald.location == 0) {
      this.add(this.ronald);
    }
    if (content.npcLocations.linda.location == 4) {
      this.add(this.linda);
    }
    // if (content.npcLocations.marvin.location == 1) {
    this.add(this.marvin);
    // }
    if (content.npcLocations.jackson.location == 4) {
      this.jackson = new FarmerJackson({ x: 18 * 16, y: 29 * 16 }, "town");
      this.jackson.z = 3;
      this.add(this.jackson);
    }
    if (content.npcLocations.cowboy.location == 0) {
      this.cowboy = new Cowboy({ x: 6 * 16, y: 26 * 16 }, "town");
      this.add(this.cowboy);
      this.cowboy.z = 3;
    }
  }
  onDeactivate() {
    this.hud.cancelHud();
    if (this.marvin !== undefined) {
      this.marvin.kill();
    }
    if (this.cowboy !== undefined) {
      this.cowboy.kill();
    }
    if (this.linda !== undefined) {
      this.linda.kill();
    }
    if (this.jackson !== undefined) {
      this.jackson.kill();
    }
    if (this.ronald !== undefined) {
      this.ronald.kill();
    }
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      if (this.interacting !== null && this.interacting !== undefined) {
        console.log(
          "interacting: ",
          this.interacting,
          " interactors: ",
          this[this.interacting]
        );
        this[this.interacting].startInteraction(
          this.player.lastDir,
          this.player
        );
        // switch (this.interacting) {

        //   case "ronald":
        //     this.ronald.startInteraction(this.player.lastDir,this.player)
        //     break;
        //   case "kaison":
        //     this.ronald.startInteraction(this.player.lastDir,this.player)
        //     break;
        //   case "roger":
        //     break;
        //   case "marvin":
        //     break;
        //   default:
        //     break;
        // }
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.I)) {
      if (!this.showingInventory) {
        this.showingInventory = true;
        this.inventoryUI = new InventoryHUD("town");
      } else {
        this.showingInventory = false;
        this.inventoryUI.destroy();
      }
    }
  }
}
